import { MetricCard } from '../ui/Card.jsx';
import { ChartCard } from './ChartCard.jsx';
import { DonutChart } from './DonutChart.jsx';

/**
 * Status → palette role, so a status ring reads semantically (won = green,
 * cancelled/expired = grey, rejected = red) rather than arbitrary cycling.
 * Within any single status set the resulting colours are distinct; statuses
 * that share a colour (ACCEPTED/CONVERTED) share an outcome by design.
 * @param {object} palette - from useChartPalette()
 * @param {string} status
 */
export function statusColor(palette, status) {
  const s = palette?.series || [];
  const map = {
    DRAFT: s[4], // info
    SENT: s[2], // warning
    CONFIRMED: s[0], // accent
    PENDING_APPROVAL: s[2], // warning
    PARTIAL: s[2], // warning
    INVOICED: s[2], // warning (orders only - no clash with SENT/PARTIAL)
    ACCEPTED: s[1], // success
    CONVERTED: s[1], // success
    FULFILLED: s[1], // success
    RECEIVED: s[1], // success
    PROCESSED: s[1], // success (completed payroll run)
    REJECTED: palette?.expense, // red
    EXPIRED: palette?.axis, // grey
    CANCELLED: palette?.axis, // grey
  };
  return map[status] ?? s[0];
}

/**
 * List-page insight strip: a status/breakdown donut beside a row of headline
 * metric cards. Mirrors the Finance invoices insight bar.
 * @param {{
 *   title: string,
 *   labels: string[],
 *   values: number[],
 *   colors?: (string|undefined)[],
 *   formatValue?: (n: number) => string,
 *   metrics: { label: string, value: React.ReactNode }[],
 * }} props
 */
export function InsightBar({ title, labels, values, colors, formatValue, metrics }) {
  return (
    <div className="dashboard-grid">
      <ChartCard title={title}>
        <DonutChart
          legend
          height={200}
          labels={labels}
          values={values}
          colors={colors}
          formatValue={formatValue}
        />
      </ChartCard>
      <div className="card-grid insight-metrics">
        {/* Auch hier der Platz statt der Beschriftung. Die Kennzahlen einer
            Seite sind zwar von Hand geschrieben und heute eindeutig - aber
            dieselbe Annahme hat die Ringlegende nebenan bereits eine
            verschluckte Zeile gekostet, und sie hält nur so lange, bis
            jemand zwei Karten gleich benennt. */}
        {metrics.map((m, i) => (
          <MetricCard key={i} label={m.label} value={m.value} />
        ))}
      </div>
    </div>
  );
}
